import React, { useContext, useEffect, useRef, useState } from "react";
import { isSuperUser } from "../../Utility";
import { MyCompanyProfileContext } from "../../MyCompanyProfileContext";
import styles from "./BulkUploadFile.module.css";
import HeaderMap from "../../utils/HeaderMap";
import * as XLSX from "xlsx";
import UploadExcel from "../CompanyProfileNew/FreightMaster/FreightMaster/UploadExcel/UploadExcel";
// import UploadFile from "../CompanyProfileNew/FreightMaster/FreightMaster/UploadExcel/Step1/UploadFile";
import { uploadAndGetLocation } from "../CompanyProfileNew/FreightMaster/FreightMaster/UploadExcel/Step1/utils";
import { UserApiContext } from "../UserDetailsContext/UserDetailsContext";
import axios from "../../Axios";
import { Urls } from "../../Urls";
import { toast } from "react-toastify";
import { useIndentTracking } from "./hooks/useIndentTracking";

const BulkUploadFile = ({
  setFile,
  finalKeys,
  file,
  step,
  fileName,
  isUploading,
  floatFromFM,
  setFloatFromFM,
  setFinalKeys,
  setData,
  setTotalRequiredFields,
  setStep,
  data,
  setNewStep,
  newStep,
  setshow,
}) => {
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const [fileNames, setFileNames] = useState([]);
  const [selectedFileFormat, setSelectedFileFormat] = useState([]);
  const [uploadedFileFormat, setUploadedFileFormat] = useState([]);
  const [inValidMessege, setInvalidMessege] = useState("");
  const inputRef = useRef();
  const { userDetails } = useContext(UserApiContext);
  const { companyProfile } = useContext(UserApiContext);
  const [newexcel_details, setnewExcel_details] = useState({});

  const uploadExcelRef = useRef(null);
  const { trackIndentEvent } = useIndentTracking();

  useEffect(() => {
    trackIndentEvent(
      "indent tracking",
      "user has viewed the indent bulk upload"
    );
  }, []);

  useEffect(() => {
    const uploadFormats = companySettingData?.indent?.upload_formats || [];
    const contactInfo = companySettingData?.contact_information || [];

    if (uploadFormats.length > 0 && contactInfo.length > 0) {
      const userBasedOrgs = isSuperUser(contactInfo);
      const allFilesName = [];

      userBasedOrgs.organizationList.forEach((org) => {
        uploadFormats.forEach((item) => {
          if (
            item.business_unit === "company" ||
            org.name === item.business_unit
          ) {
            const fileName = `${item.format_no} (${
              item?.file_info?.target
                ? item.file_info.target.value.split("\\").pop().split("-").pop()
                : item?.file_info?.name
            })`;
            allFilesName.push(fileName);
          }
        });
      });

      const uniqueFileNames = Array.from(new Set(allFilesName));
      setFileNames(uniqueFileNames);
    }
  }, [companySettingData?.indent]);

  useEffect(() => {
    setshow(true);
    axios
      .get(`${Urls.freight_master}?field=excel_logs`)
      .then((response) => {
        if (
          response.data &&
          response.data.data &&
          response.data.data.length > 0
        ) {
          let current_excel_details = response.data.data.find(
            (obj) =>
              obj?.module?.toLowerCase() === "indent" &&
              obj?.page?.toLowerCase() !== "completed" &&
              obj?.header_mapping &&
              Object.keys(obj.header_mapping).length > 0
          );
          if (!current_excel_details) {
            if (
              response.data.data[0] &&
              response.data.data[0].page !== "completed"
            ) {
              current_excel_details = response.data.data[0];
              setStep(2);
              setNewStep(2);
            } else {
              setStep(0);
              setNewStep(0);
            }
          }
          localStorage.setItem("fm_excel_id", current_excel_details.excel_id);
          setFinalKeys(current_excel_details.header_mapping);
          setnewExcel_details(current_excel_details);

          if (
            current_excel_details &&
            current_excel_details.page &&
            current_excel_details.page !== "completed" &&
            current_excel_details.header_mapping
          ) {
            if (current_excel_details.page === "location") {
              setStep(2);
              setNewStep(2);
            } else if (current_excel_details.page === "truckandtransporter") {
              setStep(2);
              setNewStep(3);
            } else if (current_excel_details.page === "confirmlanes") {
              setStep(2);
              setNewStep(4);
            }
          }
        }
        setshow(false);
      })
      .catch((err) => {
        console.error(err, "error");
        setshow(false);
      });
  }, []);

  const handleConfirm = () => {
    // existing behavior
    setNewStep(1);
    uploadAndGetLocation(
      file,
      userDetails,
      companyProfile,
      setNewStep,
      setnewExcel_details,
      finalKeys
    );
    setStep(2);

    trackIndentEvent("indent request", "user has clicked on next button after header mapping");

    // --- new: trigger uploadExcel functionality if exposed ---
    if (uploadExcelRef.current && uploadExcelRef.current.triggerFileUpload) {
      uploadExcelRef.current.triggerFileUpload();
    }
  };

  const handleChange = (e) => {
    const fileFormatNumber = e.target.value?.match(/INP-(\d+)/)?.[0];
    const selectedFormat = companySettingData?.indent?.upload_formats?.filter(
      (format) => format.format_no === fileFormatNumber
    );
    setSelectedFileFormat(selectedFormat[0]);
    handleErrorMessege(
      uploadedFileFormat,
      selectedFormat[0],
      setInvalidMessege
    );
  };

  const handleErrorMessege = (
    headers,
    selectedFileFormat,
    setInvalidMessege
  ) => {
    let flag = false;
    headers.map((item, index) => {
      if (selectedFileFormat && selectedFileFormat.length === 0) {
        flag = true;
      }
      if (item !== selectedFileFormat?.all_keys?.[index]?.label) {
        flag = true;
      }
    });
    if (flag === true && selectedFileFormat.length !== 0) {
      setInvalidMessege("Headers did not match");
    } else if (flag === true) {
      setInvalidMessege("Select a format from dropdown");
    } else if (headers && headers.length === 0) {
      setInvalidMessege("Upload a file");
    } else {
      setInvalidMessege("");
    }
  };

  const checkIfFormatMatch = (
    uploadedFileFormat,
    selectedFileFormat,
    setStep,
    setData,
    setFinalKeys,
    setTotalRequiredFields
  ) => {
    let flag = false;
    // if (uploadedFileFormat.length !== selectedFileFormat?.all_keys.length) {
    //   flag = true;
    // }
    // uploadedFileFormat.map((item, index) => {
    //   if (item !== selectedFileFormat?.all_keys?.[index]?.label) {
    //     flag = true;
    //   }
    // });
    const requiredKeys =
      selectedFileFormat?.all_keys?.map((key) => key.label) || [];

    const allKeysPresent = requiredKeys.every((key) =>
      uploadedFileFormat.includes(key)
    );

    if (!allKeysPresent) {
      flag = true;
    }
    if (flag === true) {
      toast.error("Please upload valid file");
      return false;
    } else {
      setData(selectedFileFormat?.all_keys);
      setFinalKeys(selectedFileFormat?.header_map);
      if (selectedFileFormat?.total_required_fields) {
        setTotalRequiredFields(selectedFileFormat?.total_required_fields);
      }
      trackIndentEvent(
        "indent request",
        "user has uploaded file with matching header format and clicked on submit button", `input format number : ${selectedFileFormat?.format_no}`
      );
      setStep(1);
    }
  };

  const onChangeFile = (e) => {
    const file = e.target.files[0]?.name;
    if (!file) return;
    getFileHeader(
      e,
      setFile,
      setUploadedFileFormat,
      selectedFileFormat,
      setInvalidMessege
    );
  };

  const getFileHeader = (
    e,
    setFile,
    setUploadedFileFormat,
    selectedFileFormat,
    setInvalidMessege
  ) => {
    const file = e.target.files[0];
    if (!file) return;
    setFile(e.target.files[0]);
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      if (!firstSheet) {
        toast.error("No data found in the sheet");
        return;
      }
      const allData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
      if (allData.length > 0) {
        var headers = allData[0];
        setUploadedFileFormat(headers);
      }
      handleErrorMessege(headers, selectedFileFormat, setInvalidMessege);
    };
    reader.readAsArrayBuffer(file);
  };

  return (
    <div className={`${!fileName ? styles.container1 : styles.container}`}>
      {step === 0 ? (
        <>
          <div className="d-flex w-100 justify-content-around align-items-baseline">
            <div style={{ fontSize: "13px", fontWeight: "bold" }}>
              <label>Float Indents from Freight Master:</label>
            </div>
            <div style={{ width: "30%", marginRight: "10%" }}>
              <select
                style={{ width: "130%", fontSize: "11px", height: "38px" }}
                placeholder="Select"
                onChange={(e) => setFloatFromFM(e.target.value)}
                value={floatFromFM}
                className="py-0 px-1"
              >
                <option hidden>Select</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
                {/* {fileNames.map((item, index) => (
                  <>
                    <option value={item}>{item}</option>
                  </>
                ))} */}
              </select>
            </div>
          </div>
          <div className="d-flex w-100 justify-content-around align-items-baseline">
            <div style={{ fontSize: "13px", fontWeight: "bold" }}>
              <label>Select Configured Header Format:</label>
            </div>
            <div style={{ width: "30%", marginRight: "10%" }}>
              <select
                style={{ width: "130%", fontSize: "11px", height: "38px" }}
                placeholder="Select"
                onChange={(e) => handleChange(e)}
                className="py-0 px-1"
              >
                <option hidden>Select</option>
                {fileNames.map((item, index) => (
                  <>
                    <option value={item}>{item}</option>
                  </>
                ))}
              </select>
            </div>
          </div>
          <label className={styles.inputArea}>
            <input
              id="FileInput"
              ref={inputRef}
              type="file"
              className={styles.inputBox}
              onChange={(e) => onChangeFile(e)}
              style={{ display: "block" }}
            />
            {!fileName ? (
              <div className={styles.label}>
                Drag & drop your file or choose one
              </div>
            ) : (
              <div className={styles.label}>{fileName}</div>
            )}
          </label>
          {inValidMessege !== "" && (
            <div
              style={{
                color: "red",
                fontWeight: "bold",
                width: "100%",
                textAlign: "left",
              }}
            >
              {inValidMessege}
            </div>
          )}
          <div className="d-flex w-100">
            <div style={{ width: "47%" }} className="d-flex flex-column mr-1">
              {selectedFileFormat?.all_keys &&
                selectedFileFormat?.all_keys.length > 0 && (
                  <>
                    <div style={{ fontSize: "13px", fontWeight: "bold" }}>
                      Selected Header Format:
                    </div>
                    <div
                      className="overflow-auto"
                      style={{ scrollbarWidth: "thin", height: "37vh" }}
                    >
                      {selectedFileFormat?.all_keys &&
                        selectedFileFormat?.all_keys.length > 0 &&
                        selectedFileFormat?.all_keys.map((items, index) => {
                          const isMissing = !uploadedFileFormat.includes(
                            items?.label
                          );
                          return (
                            <div
                              key={index}
                              className={isMissing ? styles.mismatchHeader : ""}
                            >
                              {items?.label}
                            </div>
                          );
                        })}
                    </div>
                  </>
                )}
            </div>
            <div style={{ width: "49%" }} className="d-flex flex-column">
              {uploadedFileFormat && uploadedFileFormat.length > 0 && (
                <>
                  <div style={{ fontSize: "13px", fontWeight: "bold" }}>
                    Uploaded File Header:
                  </div>
                  <div
                    className="overflow-auto"
                    style={{ scrollbarWidth: "thin", height: "37vh" }}
                  >
                    {uploadedFileFormat &&
                      uploadedFileFormat.length > 0 &&
                      uploadedFileFormat.map((items) => {
                        return <div>{items}</div>;
                      })}
                  </div>
                </>
              )}
            </div>
          </div>
          {uploadedFileFormat &&
            uploadedFileFormat.length > 0 &&
            selectedFileFormat?.all_keys &&
            selectedFileFormat?.all_keys.length > 0 && (
              <center className="mt-2">
                <button
                  onClick={(e) =>
                    checkIfFormatMatch(
                      uploadedFileFormat,
                      selectedFileFormat,
                      setStep,
                      setData,
                      setFinalKeys,
                      setTotalRequiredFields
                    )
                  }
                  className="btn btn-sm btn-success"
                >
                  Submit
                </button>
              </center>
            )}
        </>
      ) : step === 1 ? (
        <>
          <HeaderMap
            data={data}
            setFinalKeys={setFinalKeys}
            finalKeys={finalKeys}
            isConfigureScreen={false}
          />
          <div
            className="d-flex justify-content-center w-100 py-3"
            style={{ gap: "4px" }}
          >
            <button
              className="btn btn-secondary btn-sm mr-4"
              onClick={() => setStep(0)}
            >
              Back
            </button>
            <button
              className="btn btn-success btn-sm mr-5"
              onClick={() => handleConfirm()}
            >
              {/* {floatFromFM === "yes" ? "Next" : "Create Indent"} */}
              Next
            </button>
            {/* <button
              className="btn btn-secondary btn-sm mr-4"
            //   onClick={SecondaryFileHandler}
              disabled={isUploading }
            >
              {isUploading && (
                <>
                  <span
                    class="spinner-border spinner-border-sm border border-secondary mr-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span class="sr-only">Loading...</span>
                </>
              )}
              Overwrite Existing lanes
            </button>
            <button
              className="btn btn-success btn-sm mr-5"
              onClick={SubmitFileHandler}
              disabled={isUploading}
            >
              {isUploading && (
                <>
                  <span
                    class="spinner-border spinner-border-sm mr-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span class="sr-only">Loading...</span>
                </>
              )}
              Add new lanes
            </button> */}
          </div>
        </>
      ) : step === 2 ? (
        // --- pass ref to UploadExcel for handleConfirm trigger ---
        <UploadExcel
          isBulkUpload={true}
          headerMap={finalKeys}
          newStep={newStep}
          setNewStep={setNewStep}
          newexcel_details={newexcel_details}
          floatFromFM={floatFromFM}
          setMainStep={setStep}
          setFinalKeys={setFinalKeys}
          setFile={setFile}
          setSelectedFileFormat={setSelectedFileFormat}
          setFloatFromFM={setFloatFromFM}
          setData={setData}
          setUploadedFileFormat={setUploadedFileFormat}
        />
      ) : null}
    </div>
  );
};

export default BulkUploadFile;
